import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { DateTimeService } from '../../services/date-time.service';
import { UserInfoService } from '../../services/user-info.service';
import { StorageService } from '../../services/storage.service';
import { differenceInCalendarDays } from 'date-fns';
import { DateFormat } from '../../interfaces/base-core-services.interface';
import { RDMClientService } from '@shared-services/rdm-client.service';
import * as _ from 'lodash';
import { FinancialService } from '@shared-services/financial.service';


@Component({
  selector: 'app-payment-details',
  templateUrl: './payment-details.component.html',
})
export class PaymentDetailsComponent implements OnInit {

  public paymentDetailsGroup: FormGroup;
  public listofBanks: any[] = [];
  public listofBranchCodes: any[] = [];
  public listofBranchName: any[] = [];
  public listofpayMode: any[] = [];
  public listApproveStatus: any[] = [];
  public chequeDate: Date | null = null;
  public bankName: string;
  public bankCode: string;
  public branchName: string;
  public branchCode: string;
  public formData:any = { 'variables': {} };
  public paymentDetails = {};
  public goodsDetailAction= [];
  public load = false;
  public showPaymentMode: boolean;
  public payModeCheque: boolean;
  public payModeCash: boolean;
  @Input() public defaultFormData: string[];
  @Output() public submitedFormData = new EventEmitter<FormData>();
  public listofBranchNameBasedOnBankCode: any;

  constructor(private financialService: FinancialService,private formBuilder: FormBuilder,private rdmClientService: RDMClientService, private dataTimeService: DateTimeService, private storage: StorageService, public userInfo: UserInfoService) { }

  ngOnInit():void  {
    if (typeof this.defaultFormData === 'object') {
      this.onLoad(this.defaultFormData);
      this.load = true;
    }
  }

  onLoad(data:any):void  {
    this.paymentDetailsGroup = this.formBuilder.group({
      status: [null, [Validators.required]],
      bankName: [null],
      branchName: [null],
      chequeAmount: [null],
      chequeDate: [null],
      chequeNumber: [null],
      payMode: [null],
      receiptNumber: [null],
      depositAccountNumber: [null]
    });
    const keys = Object.keys(data.rdmData);
    keys.forEach((key) => {

      if (key.indexOf('Ics-label-banks-branches') >= 0) {
        this.listofBranchName = data.rdmData[key];
      }
      if (key.indexOf('ics_ref_dispatcher_status') >= 0) {
        this.listApproveStatus = data.rdmData[key];
      } else if (key == 'Ics-label-All-banks') {
        this.listofBanks = data.rdmData[key];
      } else if (key.indexOf('ics_ref_paymode') >= 0) {
        this.listofpayMode = data.rdmData[key];
      }
    });
  }

  approveStatus(value: string):void  {
    if (value.includes('REFDIS')) {
      this.showPaymentMode = true;
      this.paymentDetailsGroup.get("paymode")?.setValidators([Validators.required]);
    } else {
      this.showPaymentMode = false;
      this.payModeCash = false;
      this.payModeCheque = false;
      this.paymentDetailsGroup.get("paymode")?.clearValidators();

    }
  }

  disabledChequeDate = (current: Date): boolean => {
    const today = new Date();
    return differenceInCalendarDays(today, current) > 0;
  };

  onEndChange(date: Date): void {
    this.chequeDate = date;
  }


  payModeChange(value: number):void  {
    const bankName :any= this.paymentDetailsGroup.controls['bankName'] ? this.paymentDetailsGroup.controls['bankName'] : null;
    const branchName:any = this.paymentDetailsGroup.controls['branchName'] ? this.paymentDetailsGroup.controls['branchName'] : null;
    const chequeAmount:any = this.paymentDetailsGroup.controls['chequeAmount'] ? this.paymentDetailsGroup.controls['chequeAmount'] : null;
    const chequeNumber:any = this.paymentDetailsGroup.controls['chequeNumber'] ? this.paymentDetailsGroup.controls['chequeNumber'] : null;
    const receiptNumber:any = this.paymentDetailsGroup.controls['receiptNumber'] ? this.paymentDetailsGroup.controls['receiptNumber'] : null;

    if (value == 1) {
      this.payModeCheque = true;
      this.payModeCash = false;
      bankName.setValidators(Validators.required);
      branchName.setValidators(Validators.required);
      chequeAmount.setValidators(Validators.required);
      chequeNumber.setValidators(Validators.required);
      receiptNumber.clearValidators();

    } else if (value == 2) {
      receiptNumber.setValidators(Validators.required);
      this.payModeCheque = false;
      this.payModeCash = true;
      bankName.clearValidators();
      branchName.clearValidators();
      chequeAmount.clearValidators();
      chequeNumber.clearValidators();
    }
    else {
      this.payModeCheque = false;
      this.payModeCash = false;
      bankName.clearValidators();
      branchName.clearValidators();
      chequeAmount.clearValidators();
      chequeNumber.clearValidators();
      receiptNumber.clearValidators();
    }

  }

  onBankSelect(data:any) :void {
    this.bankName = data.label;
    this.bankCode = data.code;
    this.listofBranchNameBasedOnBankCode =this.rdmClientService.getRefValueListByParentId(this.listofBranchName,_.find(this.rdmClientService.getRefValues("Ics-label-All-banks"),{code:data.code})?.id)
  }
  onBranchSelect(data:any):void  {
    this.branchName = data.label;
    this.branchCode = data.code;
  }

  onSubmit():void  {
    for (const i in this.paymentDetailsGroup.controls) {
      if(i in this.paymentDetailsGroup.controls){
        this.paymentDetailsGroup.controls[i].markAsDirty();
        this.paymentDetailsGroup.controls[i].updateValueAndValidity();
      }
    }

    if (this.bankCode !== null) {
      this.formData.variables['bankCode'] = { 'value': this.bankCode };
    }

    if (this.bankName !== null) {
      this.formData.variables['bankName'] = { 'value': this.bankName };
    }

    if (this.branchCode !== null) {
      this.formData.variables['branchCode'] = { 'value': this.branchCode };
    }

    if (this.branchName !== null) {
      this.formData.variables['branchName'] = { 'value': this.branchName };
    }

    if (this.paymentDetailsGroup.value.remarks !== null) {
      this.formData.variables['chequeAmount'] = { 'value': this.paymentDetailsGroup.value.chequeAmount };
    }
    if (this.paymentDetailsGroup.value.receiptNumber !== null) {
      this.formData.variables['receiptNumber'] = { 'value': this.paymentDetailsGroup.value.receiptNumber };
    }

    if (this.paymentDetailsGroup.value.remarks !== null) {
      this.formData.variables['chequeDate'] = { 'value': this.dataTimeService.getDateFormat(this.paymentDetailsGroup.value.chequeDate, DateFormat.MM_DD_YYYY_HH_mm) };
    }

    if (this.paymentDetailsGroup.value.remarks !== null) {
      this.formData.variables['chequeNumber'] = { 'value': this.paymentDetailsGroup.value.chequeNumber };
    }

    if (this.paymentDetailsGroup.value.remarks !== null) {
      this.formData.variables['payMode'] = { 'value': this.paymentDetailsGroup.value.payMode };
    }

    if(this.paymentDetailsGroup.value.depositAccountNumber !== null){
      this.formData.variables['depositAccountNumber'] = { 'value': this.paymentDetailsGroup.value.depositAccountNumber };
    }

    if (this.paymentDetailsGroup.value.status !== null) {
      this.formData.variables['status'] = { 'value': this.paymentDetailsGroup.value.status };
      this.formData.variables['action'] = { 'value': this.paymentDetailsGroup.value.status };
    }

    this.formData.variables['operation'] = { 'value': 'Dispatch' };
    this.formData.variables['modifiedBy'] = { 'value': this.userInfo.getUserName() };
    this.formData.variables['modifiedDateAndTime'] = { 'value': this.dataTimeService.getDateFormat(new Date(), DateFormat.MM_DD_YYYY_HH_mm) };

    if (this.paymentDetailsGroup.valid) {
      this.submitedFormData.emit(this.formData);
    }


  }


}
